import client from './client'
import type { AdminStorageQuota, StorageQuotaOverridePayload } from '@/types/organisations'

export async function fetchStorageQuotaOverride(organisationId: number): Promise<AdminStorageQuota> {
  const { data } = await client.get<{ data: AdminStorageQuota }>(
    `/admin/organisations/${organisationId}/storage-quota-override`,
  )
  return data.data
}

export async function updateStorageQuotaOverride(
  organisationId: number,
  payload: StorageQuotaOverridePayload,
): Promise<AdminStorageQuota> {
  const { data } = await client.put<{ data: AdminStorageQuota }>(
    `/admin/organisations/${organisationId}/storage-quota-override`,
    payload,
  )
  return data.data
}

// DELETE carries a JSON body (the mandatory reason), same as the fee-override client.
export async function clearStorageQuotaOverride(
  organisationId: number,
  reason: string,
): Promise<AdminStorageQuota> {
  const { data } = await client.delete<{ data: AdminStorageQuota }>(
    `/admin/organisations/${organisationId}/storage-quota-override`,
    { data: { reason } },
  )
  return data.data
}
